var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnchecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 14.1C25.8613 14.1 25.6324 14.1948 25.4636 14.3636C25.2948 14.5324 25.2 14.7613 25.2 15C25.2 17.0152 24.6025 18.9852 23.4831 20.6609C22.3637 22.3366 20.7726 23.6428 18.911 24.4144C17.0494 25.186 15.0008 25.3883 13.0241 24.9958C11.0475 24.6033 9.23166 23.6336 7.80606 22.2093C6.38047 20.785 5.40916 18.9699 5.01492 16.9937C4.62068 15.0174 4.82122 12.9686 5.59117 11.1063C6.36112 9.24399 7.66593 7.65175 9.34064 6.53087C11.0154 5.40998 12.9848 4.81078 15 4.809C15.2399 4.809 15.47 4.7137 15.6396 4.54408C15.8092 4.37445 15.9045 4.14439 15.9045 3.9045C15.9045 3.66461 15.8092 3.43455 15.6396 3.26492C15.47 3.0953 15.2399 3 15 3C12.6266 3 10.3066 3.70379 8.33316 5.02236C6.35977 6.34094 4.8217 8.21509 3.91345 10.4078C3.0052 12.6005 2.76756 15.0133 3.23058 17.3411C3.6936 19.6689 4.83649 21.8071 6.51472 23.4853C8.19295 25.1635 10.3312 26.3064 12.6589 26.7694C14.9867 27.2324 17.3995 26.9948 19.5922 26.0866C21.7849 25.1783 23.6591 23.6402 24.9776 21.6668C26.2962 19.6935 27 17.3734 27 15C27 14.7613 26.9052 14.5324 26.7364 14.3636C26.5676 14.1948 26.3387 14.1 26.1 14.1Z",
    fill: "#767E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.b7d16e2470bec062978af44c54e25954.svg";
export { ForwardRef as ReactComponent };